<template>
  <div style="position: relative">
    <div class="block" style="margin-top: 20px">
      <el-timeline class="animate__animated animate__fadeInLeft">
        <el-timeline-item v-for="essay in notes" :key="essay.id" :timestamp="essay.createTime" placement="top">
          <el-card
            style="letter-spacing: 1px;padding:0 20px 20px 20px;border: 3px solid rgb(231,146,54);background-color: rgba(255,255,255,0.9);box-shadow: 0 0 30px -10px">
            <h2>{{ essay.title }}</h2>
            <div>
              <p style="word-wrap:break-word">{{ essay.content }}</p>
            </div>
            <el-image v-if="essay.image1" :src="essay.image1"></el-image>
            <el-image v-if="essay.image2" :src="essay.image2"></el-image>
            <el-image v-if="essay.image3" :src="essay.image3"></el-image>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </div>

  </div>
</template>

<script>

import request from "../utils/axiosUtils";
import base_url from "../utils/Constants";

export default {
  name: "Notes",
  data() {
    return {
      notes: [
        {},
      ],

    }
  },
  methods: {
    handleZero(time) {
      if (time < 10) {
        return '0' + time;
      } else {
        return time
      }
    },
    registerTime(data) {
      let time = new Date(
        data.substr(0, 4),
        parseInt(data.substr(5, 2)) - 1,
        data.substr(8, 2),
        data.substr(11, 2),
        data.substr(14, 2),
        data.substr(17, 2),
      );
      let year = time.getFullYear();
      let month = this.handleZero(time.getMonth() + 1);
      let day = this.handleZero(time.getDate());

      return year + '-' + month + '-' + day;

    },
  },
  mounted() {
    let that = this;
    request({
      url: '/notes/getNotes',
      method: 'get',
    }).then(response => {
      // console.log(response.data.data)
      if (response.data.data == null) {

      } else {
        let count = 1;
        response.data.data.forEach(value => {
          value.count = count++;
          if (value.image1 == null) {

          } else {
            value.image1 = base_url + '/getImage/' + value.image1;
          }

          if (value.image2 == null) {

          } else {
            value.image2 = base_url + '/getImage/' + value.image2;
          }
          if (value.image3 == null) {

          } else {
            value.image3 = base_url + '/getImage/' + value.image3;
          }

          value.createTime = that.registerTime(value.createTime);
        })
      }
      that.notes = response.data.data;
    })

  }
}
</script>

<style scoped>
.el-timeline {
  font: 16px/1.5 'Microsoft Yahei', 'PingFang SC',
  'Hiragino Sans GB', sans-serif !important;
  width: 64%;
  margin: 0 auto;
}

.el-image {
  width: 180px;
}

.el-card {
  border-radius: 20px;
  box-shadow: 0 0 15px 5px white;
}

</style>



// WEBPACK FOOTER //
// src/components/Notes.vue